import { render, staticRenderFns } from "./AuthBrandPanel.vue?vue&type=template&id=207b07f8&scoped=true"
import script from "./AuthBrandPanel.vue?vue&type=script&lang=js"
export * from "./AuthBrandPanel.vue?vue&type=script&lang=js"
import style0 from "./AuthBrandPanel.vue?vue&type=style&index=0&id=207b07f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "207b07f8",
  null
  
)

export default component.exports